import { LineDayHourAbstractInfoModel } from "./line-day-hour-abtract-info.model";

export class LineAbstractInfoModel {
    lineId: string;
    lineNumber: string;

    planQuantity: number;
    outputQuantity: number;
    reworkQuantity: number;
    productiveMinutes: number;
    downtimeMinutes: number;
    idleMinutes: number;
    totalWorkstations: number; // total workstations in the line
    efficiency: number; // the average efficiency of all hours

    hourWiseLinePerfAbstractInfo: LineDayHourAbstractInfoModel[];

    constructor(lineId: string, lineNumber: string,  planQuantity: number, outputQuantity: number, reworkQuantity: number, productiveMinutes: number, downtimeMinutes: number, idleMinutes: number, totalWorkstations: number,  efficiency: number, hourWiseLinePerfAbstractInfo: LineDayHourAbstractInfoModel[]) {
        this.lineId = lineId;
        this.lineNumber = lineNumber;
        this.planQuantity = planQuantity;
        this.outputQuantity = outputQuantity;
        this.reworkQuantity = reworkQuantity;
        this.productiveMinutes = productiveMinutes;
        this.downtimeMinutes = downtimeMinutes;
        this.idleMinutes = idleMinutes;
        this.totalWorkstations = totalWorkstations;
        this.efficiency = efficiency;
        this.hourWiseLinePerfAbstractInfo = hourWiseLinePerfAbstractInfo;
    }

    
}